import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'

const useStyles = makeStyles({
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})

/**
 * Truncate text with ellipsis, and show a tooltip with the complete text on hover.
 */
const Truncate = (props) => {
  const { text } = props
  const classes = useStyles()
  // TODO: Don't show the toltip unless the text is actually truncated.
  return (
    <Tooltip title={text} arrow className={classes.truncate}>
      <div>{text}</div>
    </Tooltip>
  )
}

Truncate.propTypes = {
  /** The text to show and truncate if necessary */
  text: PropTypes.string.isRequired,
}

export default Truncate
